import { render, staticRenderFns } from "./ConsultTransaction.vue?vue&type=template&id=f6f3a84a&scoped=true"
import script from "./ConsultTransaction.vue?vue&type=script&lang=js"
export * from "./ConsultTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f3a84a",
  null
  
)

export default component.exports